export default __webpack_public_path__ + "static/media/push-notification.16f6bc41.svg";